
import $ from 'jquery';

import { View } from 'backbone';
import contentTemplate from 'behaviors/instance-tab.ejs';
import eventBus         from 'EventBus.js';

class BehaviorView extends View {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';

        return this;
    }


    render() {
        //this.$el.empty();
        $('#' + this.model.id ).remove();
        this.$el.append(this.template( this.model.toJSON() ));

        $('.behavior-instance-close-img i').on('click', function (ev) {
            console.log('close instance');

            var thisId = ev.currentTarget.parentElement.parentElement.parentElement.id; // get this instanceId from DOM object.
            $('#' + thisId).remove();

            eventBus.trigger('behaviorInstanceClose', thisId);

            

        });
        
        $('.behavior-instance-tab').on('click', function (ev) {
            var thisId = ev.currentTarget.id; // get this instanceId from DOM object.
            eventBus.trigger('behaviorInstanceShow', thisId);
        });

        this.delegateEvents();
        return this;
    }

}

export default BehaviorView;
